module.exports = __webpack_public_path__ + "img/oops.38b28acc.svg";